import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import './index.css';
import App from './App';
import './i18n';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import theme from './theme';

// Ensure single MSAL instance even under React.StrictMode in dev
const msalInstance = (typeof window !== 'undefined' && window.__msalInstance)
  ? window.__msalInstance
  : new PublicClientApplication(msalConfig);
if (typeof window !== 'undefined') window.__msalInstance = msalInstance;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </React.StrictMode>
);

